import { Box, Alert, Typography } from "@mui/material";
import { RequestFormContext } from "../RequestFormContext";
import { ManualSignMethodCard, MagicLinkSignMethodCard } from "./SignatureMethodCard";
import { SignatureMethod } from "../Enums/SignatureMethod";
import { signatureFlowBodyBottomGapSx, signatureFlowContentGutterSx } from "../Utilities/signatureFlowLayout";

export type SignatureMethodSelectionViewProps = Omit<RequestFormContext, "pathToProp">;

export const SignatureMethodSelectionView = (props: SignatureMethodSelectionViewProps) => {
    const {
        settings,
        selectedSignatureMethod,
        setSelectedSignatureMethod,
        magicLinkUploadMethod,
        setMagicLinkUploadMethod,
        magicLinkError,
    } = props;

    const handleMethodSelect = (value: SignatureMethod) => {
        setSelectedSignatureMethod(value);
    };

    const isNoVerifiedContactsError =
        magicLinkError === "Nie sú k dispozícii žiadne emailové adresy ani telefónne čísla pre odoslanie Magic Linku.";

    return (
        <Box
            sx={{
                ...signatureFlowContentGutterSx,
                ...signatureFlowBodyBottomGapSx,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                pt: 1,
            }}
        >
            <Box>
                <Typography variant="h6" component="h2" sx={{ fontWeight: 600, color: "text.primary" }}>
                    Vyberte spôsob podpisu
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 560 }}>
                    Zvoľte jednu z možností. Ďalšie nastavenia (odoslanie linku, klient si nahrá OP) upravíte priamo v karte.
                </Typography>
            </Box>

            {magicLinkError && !isNoVerifiedContactsError && (
                <Alert
                    severity="error"
                    onClose={() => props.setMagicLinkError(null)}
                    sx={{
                        padding: "16px",
                        ".MuiAlert-message": { padding: 0 },
                    }}
                >
                    {magicLinkError}
                </Alert>
            )}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {settings.current.isMagicLinkAvailable && (
                    <MagicLinkSignMethodCard
                        selectedValue={selectedSignatureMethod}
                        value={SignatureMethod.MagicLink}
                        onSelect={handleMethodSelect}
                        magicLinkUploadMethod={magicLinkUploadMethod}
                        setMagicLinkUploadMethod={setMagicLinkUploadMethod}
                        magicLinkDeliveryMethod={props.magicLinkDeliveryMethod}
                        setMagicLinkDeliveryMethod={props.setMagicLinkDeliveryMethod}
                        magicLinkEmails={props.magicLinkEmails}
                        magicLinkPhones={props.magicLinkPhones}
                        magicLinkRecipient={props.magicLinkRecipient}
                        setMagicLinkRecipient={props.setMagicLinkRecipient}
                        isIdCardUploadRequiredForRequest={props.isIdCardUploadRequiredForRequest}
                        loadMagicLinkConfigTask={props.loadMagicLinkConfigTask}
                        onUnavailable={() => setSelectedSignatureMethod(null)}
                    />
                )}

                {settings.current.manualSignRequired && (
                    <ManualSignMethodCard
                        selectedValue={selectedSignatureMethod}
                        value={SignatureMethod.Manual}
                        onSelect={handleMethodSelect}
                    />
                )}
            </Box>
        </Box>
    );
};

